<template>
    <v-col cols="12" class="Closing mt-0 pt-0">
        <v-row
                align="stretch"
                justify="space-around"
                class="pa-4 pt-0"
                style="height: 100%"
        >
            <v-col cols="12" >
                <v-card
                        class="pa-4 elevation-0"
                        tile
                        height="100%"
                >
                    <h2 class="text-center font-weight-medium">Haz completado el Cierre</h2>
                    <v-img class="mx-auto mt-4" width="350" src="@/assets/images/cierre.jpg"></v-img>
                    <v-row class="justify-center">
                        <v-col cols="12" lg="6">
                            <p class="text-center">
                                se han generado los documentos de respaldo para<br>
                                 ambas partes. Podras encontrar todo en la página<br>
                                  Perfil de Empresa en el área<br>
                                "Mis Contratos y Docuemntos" 
                            </p>
                        </v-col>
                    
                    </v-row>
                    <v-row class="justify-center">
                         <v-btn color="primary"
                         outlined
                       raised
                       dark
                       class="pa-6">Ir a Inicio</v-btn>

                        <v-btn color="#55B303"
                       raised
                       dark
                       class="ml-2 pa-6">ir a Mis contratos y documentos</v-btn>
                    </v-row>
                </v-card>
            </v-col>
        </v-row>
    </v-col>
</template>

<script>
    export default {
        name: 'Closing',
        created: function () {
            this.$emit('SetcolorMenu', '#FE9A00');
        }
    }
</script>